export default class Layout {
    constructor(arg) {
        if (arg != undefined) {
            this.id_articolo_materia_prima_layout = arg.id_articolo_materia_prima_layout != undefined? arg.id_articolo_materia_prima_layout : -1;
            this.id_materia_prima = arg.id_materia_prima != undefined ? arg.id_materia_prima : "";
            this.layout_name = arg.layout_name != undefined ? arg.layout_name : "";
            this.file = arg.file != undefined ? arg.file : "";
            this.validita = arg.validita != undefined ? arg.validita : "";
        } else {
            this.id_articolo_materia_prima_layout = -1;
            this.id_materia_prima = -1;
            this.layout_name = "";
            this.file = "";
            this.validita = 1;
        }
    }
}